import React from 'react';
import './MissionSection.css';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const MissionSection: React.FC = () => {
  const { ref: sectionRef, style: sectionStyle } = useScrollAnimation<HTMLElement>({ delay: 0.1 });
  const { ref: labelRef, style: labelStyle } = useScrollAnimation<HTMLSpanElement>({ delay: 0.2 });
  const { ref: titleRef, style: titleStyle } = useScrollAnimation<HTMLHeadingElement>({ delay: 0.3 });
  const { ref: mainCardRef, style: mainCardStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.4 });
  const { ref: card1Ref, style: card1Style } = useScrollAnimation<HTMLDivElement>({ delay: 0.5 });
  const { ref: card2Ref, style: card2Style } = useScrollAnimation<HTMLDivElement>({ delay: 0.6 });

  return (
    <section className="mission-section" id="mission" ref={sectionRef} style={sectionStyle}>
      <div className="mission-container">
        <div className="section-header">
          <span className="section-label" ref={labelRef} style={labelStyle}>The Mission</span>
          <h2 className="section-title" ref={titleRef} style={titleStyle}>
            What is <span className="highlight">Boost+</span>?
          </h2>
        </div>

        <div className="mission-content">
          <div className="mission-card main-card" ref={mainCardRef} style={mainCardStyle}>
            <div className="card-accent"></div>
            <p className="mission-text">
              Boost+ on SOL is my <span className="highlight-text">Bags.FM</span> coin. 
              This coin is actually going to be used to fund and push my journey in the Solana Markets.
            </p>
          </div>

          <div className="mission-grid">
            <div className="mission-card" ref={card1Ref} style={card1Style}>
              <div className="card-icon">🎯</div>
              <h3>The Goal</h3>
              <p>
                I have a goal, and that goal is to make all of my coins migrate no matter what. 
                When I have a project, many can actually feel secure in investing in me.
              </p>
            </div>

            <div className="mission-card" ref={card2Ref} style={card2Style}>
              <div className="card-icon">💎</div>
              <h3>The Promise</h3>
              <p>
                Invest in me now, you won't regret it. I'm committed to building trust through 
                consistent action and results.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;